import { createAction } from '@reduxjs/toolkit';

/**
 * Represents an action that triggers the store to initialize a tenant.
 */
const action = createAction<string|undefined>('/tenant/initTenant');
export default action;
